import { render, staticRenderFns } from "./GLWiseMateriality.vue?vue&type=template&id=61f0d353&scoped=true"
import script from "./GLWiseMateriality.vue?vue&type=script&lang=js"
export * from "./GLWiseMateriality.vue?vue&type=script&lang=js"
import style0 from "./GLWiseMateriality.vue?vue&type=style&index=0&id=61f0d353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0d353",
  null
  
)

export default component.exports